import { useCallback, useState } from 'react';
import { useQuery } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { ALL_OPTION_KEY } from '@/common/constants';
import { API_URL } from '@/dtos';

import { useDownloadCSV } from '../../hooks';
import { PlanOmnibusBalanceSummaryReportParams } from '../PlanOmnibusBalanceReport.types';

export const QUERY_KEY = 'EXPORT_PLAN_OMNIBUS_BALANCE_SUMMARY_REPORT_CSV';
const usePlanOmnibusBalanceReportExportSummaryCSVQuery = (params: PlanOmnibusBalanceSummaryReportParams) => {
  const handleSaveFile = useDownloadCSV();
  const [isLoading, setIsLoading] = useState(false);
  const { refetch } = useQuery(
    [QUERY_KEY],
    () =>
      api.get(API_URL.REPORTS_PLAN_OMNIBUS_BALANCE_REPORT_SUMMARY_EXPORT_CSV, {
        params: _.pickBy({
          employer_id: params.employerId,
          plan_year_period:
            params?.planYearPeriod && !params?.planYearPeriod.includes(ALL_OPTION_KEY)
              ? params?.planYearPeriod.join(',')
              : undefined,
          plan_ids:
            params?.planIds && !params?.planIds.includes(ALL_OPTION_KEY)
              ? params?.planIds.join(',')
              : undefined,
        }),
      }),
    {
      retry: 0,
      enabled: false,
    }
  );

  const handleExport = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await refetch();
      handleSaveFile(response.data?.data, 'csv', 'plan_omnibus_balance_summary');
    } finally {
      setIsLoading(false);
    }
  }, [handleSaveFile, refetch]);
  return {
    isLoading,
    handleExport,
  };
};

export default usePlanOmnibusBalanceReportExportSummaryCSVQuery;
